import React, { forwardRef, useEffect, useState } from "react";
import BranchSearch from "../BranchSearch";
import { Button } from "react-bootstrap";

function createUrl(radius, type, address) {
    const params = [];

    if (address) {
        params.push(`search=${address}`);
    }

    if (radius) {
        params.push(`rad=${radius}`);
    }

    if (type) {
        params.push(`type=${type}`);
    }

    return params.join("&");
}

export default forwardRef(({ loadMap, cmsId, editorClassObj }: any, ref: any) => {
    const [type, setType] = useState(1);
    const [value, setValue] = useState("");
    const [radius, setRadius] = useState(25);
    const [url, setUrl] = useState("");

    useEffect(() => {
        setUrl(createUrl(radius, type, value));
    }, [radius, type, value])

    function handleChange(value, radius, type) {
        setValue(value);
        setRadius(radius);
        setType(type);
    }

    function handleSearch(lat, lng, radius, type, address) {
        const params = createUrl(radius, type, address);
        window.location.href = `/branch-locations${params ? ("?" + params) : ""}`;
    }

    return (
        <div data-id={cmsId} className={editorClassObj} ref={ref}>
            <BranchSearch
                loadMap={loadMap}
                defaultValue={value}
                defaultRadius={radius}
                defaultType={type}
                onChange={handleChange}
                onSearch={handleSearch}>
                <Button
                    className="h-100 d-flex align-items-center"
                    href={`/branch-locations${url ? ("?" + url) : ""}`}>Search</Button>
            </BranchSearch>
        </div>
    );
});